/**
 * ThemeContext — Iter 99 (Feb 2026)
 *
 * Iter 98 retiró el modo claro y las 4 paletas porque nunca llegaron a
 * verse bien con todos los componentes (sidebar, badges, modales y selects
 * tenían clases `bg-zinc-950/900` hardcoded). La app fuerza modo oscuro.
 *
 * Mantengo el `ThemeProvider` y `useTheme()` con la misma API para evitar
 * romper imports existentes. `setTheme` y `toggleTheme` son no-ops.
 */
import React, { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext({
  theme: "dark",
  setTheme: () => {},
  toggleTheme: () => {},
});

export function ThemeProvider({ children }) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("dark");
    root.setAttribute("data-theme", "dark");
    // Limpieza de selección antigua de paleta luz (Iter 95)
    try {
      localStorage.removeItem("dnf_theme");
      localStorage.removeItem("dnf_light_palette");
    } catch {
      /* ignore */
    }
  }, []);
  return (
    <ThemeContext.Provider value={{ theme: "dark", setTheme: () => {}, toggleTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
